import { TreatmentPlanAppointment } from "../services/treatmentPlanService";

type TreatmentPlanStep = TreatmentPlanAppointment["steps"][0];

export function getAppointmentFee(appointment: TreatmentPlanAppointment): number {
  if (appointment.totalFee != null) {
    return appointment.totalFee;
  }
  let total = 0;
  appointment.steps.forEach((step) => {
    if (step.fee != null) {
      total += step.fee;
    } else {
      step.codeSuggestions.forEach((code) => {
        total += code.defaultFee || 0;
      });
    }
  });
  return total;
}

export function getAppointmentDuration(
  appointment: TreatmentPlanAppointment,
): string {
  if (appointment.totalDurationMinutes != null) {
    return `${appointment.totalDurationMinutes} min`;
  }
  let totalMinutes = 0;
  appointment.steps.forEach((step) => {
    totalMinutes += step.durationMinutes ?? 20;
  });
  return `${totalMinutes} min`;
}

export function getProcedureFee(step: TreatmentPlanStep): number {
  if (step.fee != null) {
    return step.fee;
  }
  return step.codeSuggestions.reduce(
    (sum, code) => sum + (code.defaultFee || 0),
    0,
  );
}

export function getOptionLabel(
  conditionalPath: string | null | undefined,
): string | null {
  if (!conditionalPath || conditionalPath.trim() === "") {
    return null;
  }
  const rawPath = conditionalPath.trim();
  return rawPath.toLowerCase().startsWith("option")
    ? rawPath.replace(/^option\s*/i, "")
    : rawPath;
}
